const getImgUrl = function(i) {
  const images = require.context("../assets/logos", false, /\.png$/);
  return images("./" + i + ".png");
};

export { getImgUrl };
